const SECTIONS = [
  {
    title: "제1조 (목적)",
    body: "이 약관은 ARTPASS(이하 '서비스')가 제공하는 실물 미술품 등록·등기·소유권 이전 이력 관리 서비스의 이용조건 및 절차, 회원과 서비스 간의 권리·의무 및 책임사항을 정함을 목적으로 합니다.",
  },
  {
    title: "제2조 (서비스의 내용)",
    body: "서비스는 실물 미술품을 등록하고, 관리자 심사를 거쳐 로컬 테스트 체인에서 작품당 1개의 등기 NFT를 발행하며, 진품확인서 발급과 소유권 이전 이력 관리를 제공합니다. 현재 서비스는 베타(프로토타입)로 운영되며 모든 등록·발행·이전은 테스트 체인(로컬 개발 네트워크)에서만 이루어집니다. 등기 NFT와 인증서는 서비스가 확인한 등록·이전 사실의 증빙일 뿐이며, 실제 자산이나 법적 소유권 증명이 아니므로 실물 거래의 근거로 사용할 수 없습니다.",
  },
  {
    title: "제3조 (회원가입)",
    body: "회원가입은 이용자가 이메일·비밀번호·이름 등 필요한 정보를 입력하고 이 약관 및 개인정보처리방침에 동의함으로써 성립합니다. 이용자는 작가 또는 화랑으로 활동하는 경우 해당 역할을 선택할 수 있으며, 등록관리자(REGISTRAR) 권한은 자가 회원가입으로 부여되지 않고 별도 절차를 통해서만 부여됩니다.",
  },
  {
    title: "제4조 (회원의 의무)",
    body: "회원은 가입 시 정확한 정보를 입력해야 하며, 계정 정보(비밀번호 등)를 스스로 관리할 책임이 있습니다. 작품을 등록하는 회원은 등록 정보와 이미지가 실물과 일치함을 보증해야 하며, 소유권 이전 절차에서는 실물 인도 확인 등 서비스가 정한 절차상 의무를 성실히 이행해야 합니다. 타인의 계정을 무단으로 사용하거나 허위 정보를 등록하는 행위는 금지됩니다.",
  },
  {
    title: "제5조 (서비스 이용의 제한 및 계정 정지)",
    body: "서비스는 회원이 허위 등록, 부정 이용, 타인의 권리 침해 등 이 약관을 위반한 경우 사전 통지 후(긴급한 경우 사후 통지) 해당 회원의 서비스 이용을 제한하거나 계정을 정지할 수 있습니다.",
  },
  {
    title: "제6조 (지식재산권)",
    body: "등록된 작품에 대한 저작권 및 기타 지식재산권은 원작자 또는 정당한 권리자에게 있으며, 서비스는 등록 사실과 이력을 증빙할 뿐 저작권을 취득하거나 이전받지 않습니다. 작품을 등록하는 회원은 해당 작품에 대해 등록에 필요한 정당한 권한이 있음을 보증해야 합니다.",
  },
  {
    title: "제7조 (면책조항)",
    body: "서비스는 현재 베타로 무상 제공되며, 테스트 체인의 특성상 체인 노드 재시작 시 온체인 기록이 소실될 수 있습니다. 서비스는 등기 NFT나 인증서가 실물 미술품의 법적 소유권을 증명한다고 보장하지 않으며, 회원 간 실물 거래 과정에서 발생하는 분쟁에 대해 직접적인 책임을 지지 않습니다. 서비스는 관련 법령이 허용하는 범위에서 이 조항에 따른 책임 제한의 이익을 누립니다.",
  },
  {
    title: "제8조 (약관의 변경)",
    body: "서비스는 필요한 경우 이 약관을 변경할 수 있으며, 변경 시 서비스 내 공지 또는 이에 준하는 방법으로 사전에 안내합니다. 변경된 약관은 공지된 시점부터 효력이 발생합니다.",
  },
  {
    title: "제9조 (문의)",
    body: "이 약관과 관련하여 궁금한 사항은 등록관리자에게 문의해주세요.",
  },
  {
    title: "부칙",
    body: "이 약관은 2026년 8월 13일부터 적용됩니다.",
  },
];

export function TermsContent() {
  return (
    <div className="flex flex-col gap-5">
      {SECTIONS.map((s) => (
        <section key={s.title}>
          <h3 className="mb-1.5 text-sm font-medium text-ink">{s.title}</h3>
          <p className="text-sm leading-relaxed text-body">{s.body}</p>
        </section>
      ))}
    </div>
  );
}
